import React from "react";
import { HiLocationMarker } from "react-icons/hi";
import { IoCall, IoMail } from "react-icons/io5";
import "./ContactInfo.css";

const ContactInfo = () => (
  <section className="contact-details" aria-label="Contact details">
    <article className="contact-details__card">
      <span className="contact-details__icon"><HiLocationMarker /></span>
      <h2>Office</h2>
      <p>Thane, Maharashtra</p>
      <small>Survey No 16/1, Laxmi Baug N.H-8, Mira Road (E)</small>
    </article>
    <article className="contact-details__card contact-details__card--featured">
      <span className="contact-details__icon"><IoCall /></span>
      <h2>Phone</h2>
      <p><a href="tel:+918655016069">+91 86550 16069</a><br /><a href="tel:+918655036068">+91 86550 36068</a></p>
      <small>Monday to Saturday · 9:00 AM to 6:00 PM</small>
    </article>
    <article className="contact-details__card">
      <span className="contact-details__icon"><IoMail /></span>
      <h2>Email</h2>
      <p><a href="mailto:sales@hardcoatsindia.com">sales@hardcoatsindia.com</a><br /><a href="mailto:info@hardcoatsindia.com">info@hardcoatsindia.com</a></p>
    </article>
  </section>
);

export default ContactInfo;
